(() => {
  const initFeatureCardMediaTicker = (section) => {
    if (!section) return;

    const tickers = section.querySelectorAll(".js-feature-card-media-ticker");
    if (tickers.length === 0) return;

    tickers.forEach((tickerEl) => {
      if (tickerEl.swiper) {
        tickerEl.swiper.destroy(true, true);
      }

      const slideEls = tickerEl.querySelectorAll(
        ".feature-card__feature-media-list-item"
      );
      if (slideEls.length < 2) return;

      const isOverBackground = !!tickerEl.closest(
        ".feature-card__feature-media--over-background"
      );

      new Swiper(tickerEl, {
        speed: 12000,
        slidesPerView: "auto",
        spaceBetween: isOverBackground ? 0 : 16,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        watchSlidesProgress: true,
        loop: true,
        loopedSlides: slideEls.length,
        freeMode: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        simulateTouch: false,
        a11y: {
          scrollOnFocus: false,
        },
      });
    });
  };

  initFeatureCardMediaTicker(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initFeatureCardMediaTicker(event.target);
  });

  document.addEventListener("shopify:section:reorder", function (event) {
    initFeatureCardMediaTicker(event.target);
  });

  document.addEventListener("shopify:block:update", function (event) {
    const section = event.target.closest(".feature-cards-section");
    if (!section) return;
    initFeatureCardMediaTicker(section);
  });
})();
